import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

export interface UpdateEventBudgetInput {
  eventId: number;
  budget: number | null;
}

export interface UpdateEventBudgetResult {
  updateEventBudget: {
    ok: boolean;
    event: {
      id: number;
      budget: number | null;
    };
  };
}

const UpdateEventBudgetMutation = gql`
  mutation updateEventBudget($input: UpdateEventBudgetInput!) {
    updateEventBudget(input: $input) {
      ok
      event {
        id
        budget
      }
    }
  }
`;

export const updateEventBudget = async (input: UpdateEventBudgetInput): Promise<number | null> => {
  const result = await gqlClient.request<UpdateEventBudgetResult>(UpdateEventBudgetMutation, {
    input
  });

  return result.updateEventBudget.event.budget;
};
